import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const Register = () => {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(form);
      navigate("/");
    } catch (err) {
      setError(err?.response?.data?.detail || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-12 bg-[#f6f3ee]">
      <div className="w-full max-w-md bg-white border border-neutral-200 rounded-sm p-8">
        <div className="text-center mb-6">
          <img src="/logo.png" alt="Deegford" className="h-16 w-auto object-contain mx-auto mb-4" />
          <h1 className="font-serif text-3xl text-neutral-900">Create Account</h1>
          <p className="text-sm text-neutral-500 mt-2">Join the Deegford circle</p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          {[
            { label: "Full Name", key: "name", type: "text", req: true },
            { label: "Email", key: "email", type: "email", req: true },
            { label: "Phone", key: "phone", type: "tel", req: false, ph: "+91 ..." },
            { label: "Password", key: "password", type: "password", req: true, min: 6 },
          ].map(({ label, key, type, req, ph, min }) => (
            <div key={key}>
              <label className="block text-sm font-medium text-neutral-700 mb-1.5">{label}</label>
              <input
                required={req} type={type} value={form[key]} onChange={update(key)}
                placeholder={ph} minLength={min}
                className="w-full border border-neutral-300 rounded-sm px-3 py-2.5 text-sm focus:outline-none focus:border-[#C8932F]"
              />
            </div>
          ))}
          {error && <p className="text-sm text-red-600">{error}</p>}
          <button type="submit" disabled={loading}
            className="w-full bg-gradient-to-br from-[#FFE29A] to-[#C8932F] text-[#050304] py-3 text-sm font-semibold uppercase tracking-widest rounded-sm hover:opacity-90 transition-opacity flex items-center justify-center gap-2 disabled:opacity-60">
            {loading ? <><Loader2 className="h-4 w-4 animate-spin" /> Creating...</> : "Create Account"}
          </button>
        </form>
        <p className="text-center text-sm text-neutral-600 mt-6">
          Already have an account? <Link to="/login" className="text-[#C8932F] font-medium hover:underline">Sign in</Link>
        </p>
      </div>
    </div>
  );
};

export default Register;
